import styled from "styled-components";

export const ButtonPage = styled.button`
  @font-face {
    font-family: "Get Schwifty";
    src: url("fonts/get_schwifty.ttf") format("woff");
  }

  :hover {
    color: #d3d3d3;
  }

  font-family: "Get Schwifty";
  background-color: transparent;
  border: none;
  color: ${(props) => `${props.buttonColor}`};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  cursor: pointer;
`;
